module.exports = __webpack_public_path__ + "img/star.955e2b47.svg";